<div class="wrapper wrapper-content mtv-directory-page animated fadeInRight row hide-list-nav-tabs settings-amenities">
    <div class="ibox mainPartPage"
         [class.showDetailedView]="settingsPassOnLogService.showDetailedView"
         [ngStyle]="{width: settingsPassOnLogService.showDetailedView ? 'calc(100% - 520px)' : '100%'}">
        <div class="ibox-content no-scroll-mode">
            <div class="row">
                <div class="col-sm-12">
                    <filter [tabHeading]="'Settings Pass On Log'" [buildings]="settingsPassOnLogService.buildingsForRead"></filter>
                </div>
            </div>
            <tabs-wrapper>
                <tab-item [tabId]="'allSettingsPassOnLog'"
                          [ngClass]="{'sk-loading': settingsPassOnLogService.spinnerShow}">
                    <settings-pass-on-log-list></settings-pass-on-log-list>
                    <spinner [spinnerShow]="settingsPassOnLogService.spinnerShow"></spinner>
                </tab-item>
                <pagination *ngIf="settingsPassOnLogService.corporations.data.length > 0 && urlService.queryParams['page']"
                            [total]="settingsPassOnLogService.corporations.total">
                </pagination>
            </tabs-wrapper>
        </div>
    </div>

    <div class="animated animated-directory slideInRight detailed-view dv-sidebar"
         *ngIf="settingsPassOnLogService.showDetailedView">
        <settings-pass-on-log-detailed-view></settings-pass-on-log-detailed-view>
    </div>
</div>
<notification-modal *ngIf="settingsPassOnLogService.isNotificationModalShow"></notification-modal>



// WEBPACK FOOTER //
// /app/src/app/views/settings-pass-on-log/settings-pass-on-log.component.html